export default function DownloadSection() {
  return (
    <section
      id="downloadSection"
      className={`w-full md:min-h-screen flex max-md:flex-col-reverse justify-between max-md:py-7`}
    >
      <div className="myContainer w-full flex max-lg:flex-col max-lg:items-center max-lg:gap-5 justify-center lg:justify-between min-h-full">
        <div className={`w-full md:w-1/2 relative max-lg:flex`}>
          <img
            src="/img/home/iphoneMockup.png"
            alt="MockUp"
            className={`xl:absolute bottom-0`}
          />
        </div>
        <div
          className={`w-full lg:w-1/2 *:lg:w-3/4 flex flex-col justify-center max-md:mt-5`}
        >
          <span
            className={`text-black text-2xl lg:text-[28px] font-bold text-right`}
          >
            همین حالا اپلیکیشن ما رو دانلود کن!
          </span>
          <p
            className={`text-myNeutral26 text-lg leading-loose tracking-wider text-justify`}
          >
            آماده‌ای برای سفری جذاب به سوی زندگی سالم‌تر و سبزتر؟ با اپلیکیشن
            ما، می‌تونی هر روز با فعالیت‌های ساده مثل پیاده‌روی یا صرفه‌جویی در
            مصرف منابع، هم به خودت کمک کنی و هم به زمین. <br />
            فرصت رو از دست نده! اپلیکیشن رو همین الان دانلود کن و اولین قدمت رو
            به سوی آینده‌ای بهتر بردار. با هم می‌تونیم دنیامون رو تغییر بدیم! 🌿
          </p>
          <div
            className={`w-full flex max-md:flex-col justify-center md:justify-between gap-3 items-center mt-10`}
          >
            <a
              href="http://cafebazaar.ir/app/?id=com.gameandgrow.gameandgrow"
              // download="G&G.apk"
              className={`w-1/2 md:w-[calc(33.33%-8px)] h-full *:h-full *:object-fill`}
            >
              <img
                src="/img/home/badge-new.png"
                alt="Download Btn"
                className={`max-md:w-full aspect-[177/67]`}
              />
            </a>
            <a
              href="https://gameandgrow.com/G&G(newerPhone).apk"
              download={`G&G.apk`}
              className={`w-1/2 md:w-[calc(33.33%-8px)]`}
            >
              <img
                src="/img/home/badge-new-android-new.png"
                alt="Download Btn Android New"
              />
            </a>
            <a
              href="https://gameandgrow.com/G&G(olderPhone).apk"
              download={`G&G.apk`}
              className={`w-1/2 md:w-[calc(33.33%-8px)]`}
            >
              <img
                // className={`md:rounded-2xl`}
                src="/img/home/badge-new-android.png"
                alt="Download Btn Android Old"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
